$(document).ready(function () {
    $( "#news-review-tabs" ).tabs();
    showReportParagraphComponent();
})

function loadMoreNews(newsType, loadMore, tabName) {
	var newsOffset;
	if (loadMore) {
		newsOffset = getNewsOffsetValue();
	} else {
		newsOffset = parseInt(0);
	}
	$.ajax({
		url: "/news/type/" + newsType,
		data: { offset: newsOffset },
		type: 'GET',
		success: (data) => {
			$('#newsOffset').remove(); // Remove existing newsOffSet element
			if (loadMore) {
				$(`#${tabName}`).append(data);
			} else {
				$('#activeNewsType').remove(); // Remove existing activeNewsType span element
				$('#newsOffset').remove();
				$('#newsTotalCount').remove();
				$(`#${tabName}`).empty();
				$(`#${tabName}`).append(data);
				var activeNewsType = $("#activeNewsType").text(); // Update the "Load More" button's onClick event when switching between news types.
				$("#loadMoreNews").attr("onclick", "loadMoreNews('" + activeNewsType + "', true, '" + tabName + "')")
			}
			var newsTotalCount = parseInt($("#newsTotalCount").html());
			newsOffset = getNewsOffsetValue();
			if (newsTotalCount <= newsOffset) { // Hide the "Load More" button if there are no more news.
				$("#loadMoreNews").hide();
			} else {
				$("#loadMoreNews").show();
			}
		},
	});
}

function bindReadReportButton(){
    var formID = $("#report-form");
    if(!formID.valid()){
        event.preventDefault();
    }
    else{
    $("#js-read-report").attr('disabled','disabled');
   ACC.salesforce.createSalesForceObject('Default','#report-form','#readTheReport','#js-read-report',false);
    }
}

function getNewsOffsetValue() {
	var newsOffsetSpan = $("#newsOffset").html();
	return newsOffset = parseInt(newsOffsetSpan);
}

function showReportParagraphComponent() {
	const newsType = $('#acimaNewsPageNewsType').attr('data-value');
	if (newsType === 'REPORTS') {
		$('.news-report-page-para-component').removeClass('d-none');
		$(".news-report-page-para-component").clone().appendTo($(".inside_the_report_wrapper"));
		$(".content .news-report-page-para-component").remove();

	} else {
		$(".content .news-report-page-para-component").remove();
	}
}